export default __webpack_public_path__ + "static/media/real_face.9598087e.jpg";